class AccountLogs {
    constructor() {
        this.loadAccountLogsTable();
    }
    loadAccountLogsTable(){
        let accountLogsTab = document.querySelector('a[href="#account_logs_tab"]');
        accountLogsTab.addEventListener("click", function() {
            new AccountLogsDatatable();
        }, {once : true});
    }
}
window.AccountLogs = AccountLogs;